export default __webpack_public_path__ + "static/media/1.dd200ea6.svg";